import BaseApi from '../BaseApi';
import Converter from './Converter';

class Api extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin`;
    this.converter = new Converter();
  }

  setCustomProviders = providers => this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/custom/providers`, providers);

  setCustomGames = games => this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/custom/games`, games);

  setSocialRequest = data => this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/custom_request/social_links`, data);

  getCustomProviders = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/custom/providers`,
      undefined,
      undefined,
      this.converter.convertCustomProviders,
    );

  getCustomRequests = formData =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/custom_requests`,
      formData,
      undefined,
      this.converter.convertCustomRequests,
    );

  getSocialMedia = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/metadata`,
      undefined,
      undefined,
      this.converter.convertSocialMedia,
    );

  getCustomGames = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/custom/games`,
      undefined,
      undefined,
      this.converter.convertCustomGames,
    );

  getSingleCustomRequest = id =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/custom_requests/${id}`,
      undefined,
      undefined,
      this.converter.convertSingleCustomRequest,
    );

  approveCustomRequest = data =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/custom_requests/${data.id}/approve`, data);

  deleteCustomRequest = data =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/custom_requests/${data.id}/delete`, undefined);

  createCustomNotification = formData =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/custom/notifications`, formData, undefined, undefined);
}

export default Api;
